<template>
  <b-row class="menu-permissao">
    <b-col cols="12">
      <b-tabs card>
        <b-col
          v-for="item in value"
          :key="item.id"
          cols="12"
        >
          <b-tab
            no-body
            :title="item.recurso.descricao.charAt(0).toUpperCase() + item.recurso.descricao.slice(1)"
          >
            <b-row class="mb-1">
              <b-col cols="7">
                <h4>Recursos</h4>
                <fieldset class="font-weight-bold text-muted small">
                  Nome dos recursos
                </fieldset>
              </b-col>
              <b-col>
                <h4>Permissões</h4>
                <fieldset class="font-weight-bold text-muted small">
                  Permissões de cada menu
                </fieldset>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-row
                  align-v="center"
                  class="menu-permissao-linha"
                  @click="checkMenu(item)"
                >
                  <b-col>
                    <permissoes
                      v-if="!item.filhos || item.filhos.length == 0"
                      v-model="item.permissao"
                      :admin="admin"
                      :disabled="!item.habilitado"
                      :portal="item.habilitado && item.regraRecurso === 'somentealteracao'"
                      :sem-remocao="item.habilitado && item.regraRecurso === 'semremocao'"
                      :todos-campos="item.habilitado && item.regraRecurso === 'todoscampos'"
                    />
                  </b-col>
                </b-row>

                <b-collapse
                  visible
                >
                  <b-row>
                    <b-col>
                      <menu-permissao-item
                        v-if="item.filhos && item.filhos.length > 0"
                        v-model="item.filhos"
                        :posicao="1"
                        :admin="admin"
                        @input="sendToParent()"
                      />
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-col>
            </b-row>
          </b-tab>
        </b-col>
      </b-tabs>
    </b-col>
  </b-row>

</template>

<style lang="scss">
.recuo-sem-filhos {
  padding-top: 0.5rem !important;
  padding-right: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  padding-left: 0.5rem !important;
  width: 14px !important;
}

.menu-permissao .menu-permissao-linha {
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: rgba(248, 248, 248, 0.95);
  }
}
</style>

<script>

export default {
  name: 'MenuPermissao',
  components: {
    Permissoes: () => import('./Permissao.vue'),
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    admin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disabledInner: false,
      itemSelecionado: null,
      colunasPermissao: ['criar', 'visualizar', 'alterar', 'remover'],
    }
  },
  methods: {
    selecionarTudo(selecionar) {
      if (selecionar) {
        this.admin = true
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.value.length; i++) {
          // eslint-disable-next-line no-plusplus
          for (let j = 0; j < this.value[i].filhos.length; j++) {
            this.$set(this.value[i].filhos[j], 'administrador', true)
            this.$set(this.value[i].filhos[j], 'habilitado', true)
            this.$set(this.value[i].filhos[j], 'permissoes', {
              adicionar: true,
              visualizar: true,
              alterar: true,
              remover: true,
            })
          }
        }
      } else {
        this.admin = false
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.value.length; i++) {
          // eslint-disable-next-line no-plusplus
          for (let j = 0; j < this.value[i].filhos.length; j++) {
            this.$set(this.value[i].filhos[j], 'administrador', false)
          }
        }
      }
    },
    checkMenu(value) {
      this.itemSelecionado = value
    },
    sendToParent() {
      this.$emit('input', this.value)
    },
  },
}
</script>
